<template>
  <div class="m-title">
    <img :src="icon" alt="" />
    <span>{{ title }}</span>
  </div>
</template>

<script>
export default {
  props: {
    title: String,
    icon: String,
    titleColor: {
      type: String,
      default: "#333333",
    },
  },
};
</script>
<style lang="scss" scoped></style>
